/* ═══════════════════════════════════════
   MAXGOLDSCHMIED FINAL · MAIN JS
   assets/mg-main.js
═══════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', () => {

  /* ── Header scroll ── */
  const hdr = document.getElementById('mg-hdr');
  if (hdr) {
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('sc', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── Mobile menu ── */
  window.mgToggleMenu = function() {
    const nav = document.getElementById('mg-mob-nav');
    if (nav) nav.classList.toggle('open');
  };

  /* ── Video play ── */
  window.mgPlayVid = function(videoId, overlayId) {
    const v = document.getElementById(videoId);
    const o = document.getElementById(overlayId);
    if (v) { v.play(); if (o) o.style.display = 'none'; }
  };

  /* ── FAQ accordion ── */
  window.mgToggleFaq = function(btn) {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(el => {
      el.classList.remove('open');
      const b = el.querySelector('.faq-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  /* ── Scroll fade animations ── */
  const fades = document.querySelectorAll('.fu');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -36px 0px' });
    fades.forEach(el => obs.observe(el));
  } else {
    fades.forEach(el => el.classList.add('vis'));
  }

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});
